import { Component } from 'react'

export class SortBy extends Component {

	constructor( props ) {
		super( props )

		this.state = {
			options: [
				{ 
					name: 'Relevance', 
					value: '',
				},
				{ 
					name: 'Title A-Z', 
					value: 'asc',
				},
				{ 
					name: 'Title Z-A', 
					value: 'desc',
				},
			],
			dropdownHidden: true
		}

		this.toggleDropdown = this.toggleDropdown.bind( this )
	}

	toggleDropdown() {
		this.setState({ dropdownHidden: !this.state.dropdownHidden })
	}

	selectOption( value ) {
		this.props.updateFilter( 'sort_by', value )
		this.toggleDropdown()
	}

	render() {
		let sortByClass = this.state.dropdownHidden ? 'hide-list' : 'show-list'

		let optionText = ''
		if ( '' !== this.props.currentSortBy ) {
			let selectedOption = this.state.options.find( option => option.value === this.props.currentSortBy )
			console.log( selectedOption )

			if ( selectedOption.name ) {
				optionText = ( <span className="pf-sort-by__selected-option">{ selectedOption.name }</span> )
			}
		}

		return (
			<div className={ `pf-sort-by ${sortByClass}` }>
				<button className="pf-sort-by__button" onClick={ this.toggleDropdown }>
					<strong>Sort By</strong>
					{ optionText }
				</button>

				<ul className="pf-sort-by__dropdown" aria-hidden={ this.state.dropdownHidden }>
					{this.state.options.map( ( { name, value }, index ) => {
						let activeClass = value === this.props.currentSortBy ? 'pf-sort-by__dropdown-item--selected' : ''
						return (
							<li 
								className={ `pf-sort-by__dropdown-item ${activeClass}` } 
								role="link" 
								key={ index }
								onClick={ () => this.selectOption( value ) }
							>
								{ name }
							</li>
						)
					})}
				</ul>
			</div>
		)
	}
}